import React, {useEffect, useState} from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { Menubar } from 'primereact/menubar';
import { PanelMenu } from 'primereact/panelmenu';
import { Button } from 'primereact/button';
import { Image } from 'primereact/image';

import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import endpoints from "./constants/env/middletier";
import LogoutButton from "./components/LogoutButton";
import ProjectContextDropdown from './components/ProjectContextDropdown';
import { useAuth } from './AuthProvider'

export default function MainLayout() {

    const navigate = useNavigate();
    const [sidebarVisible, setSidebarVisible] = useState(true);
    const [expandedKeys, setExpandedKeys] = useState({});
    const [lookups, setLookups] = useState({});
    const { keycloak } = useAuth()

    useEffect(() => {
        async function fetchLookups() {
            try {
                // const res = await fetch(Endpoints["lookups"]);

                await keycloak.updateToken(30);

                const res = await fetch(`${endpoints.lookups}`, {
                // const res = await fetch(Endpoints["lookups"], {
                    headers: {
                        Accept: 'application/json',
                        Authorization: `Bearer ${keycloak.token}`,
                    },
                });



                const data = await res.json();

                setLookups(data);
                console.log("Data Lookups");
                console.log(data);
            } catch (err) {
                console.error("Failed to load lookups", err);
            } finally {
                // setLoading(false);
            }
        }
        fetchLookups();
    }, []);



    // {
    //     label: 'Check Lists',
    //         icon: 'pi pi-list-check',
    //     command: () => navigate('/sample')
    // },



    const topMenuItems = [
        {
            label: 'Upload',
            icon: 'pi pi-upload',
            command: () => navigate('/upload')
        },
        {
            label: 'Projects',
            icon: 'pi pi-building',
            command: () => navigate('/cxprojects')
        },
        {
            label: 'Equipment',
            icon: 'pi pi-cog',
            command: () => navigate('/cxequipment')
        },
        {
            label: 'Systems',
            icon: 'pi pi-objects-column',
            command: () => navigate('/cxsystems')
        },
        {
            label: 'Checklists',
            icon: 'pi pi-list-check',
            command: () => navigate('/cxchecklist')
        },
        {
            label: 'Import Logs',
            icon: 'pi pi-book',
            command: () => navigate('/logs')
        },
    ];

    const panelItems = [
        {
            label: 'Core Records',
            icon: 'pi pi-file',
            items: [
                {
                    label: 'Projects',
                    icon: 'pi pi-building',
                    command: () => navigate('/projects')
                },
                {
                    label: 'Clients',
                    icon: 'pi pi-users',
                    command: () => navigate('/clients')
                }
            ]
        },
        {
            label: 'Assets',
            icon: 'pi pi-cloud',
            items: [
                {
                    label: 'Equipment',
                    icon: 'pi pi-hammer'
                },
                {
                    label: 'Equipment Types',
                    icon: 'pi pi-clone'
                },
                {
                    label: 'Systems',
                    icon: 'pi pi-server'
                }
            ]
        },
        {
            label: 'Lists',
            icon: 'pi pi-list',
            items: [
                {
                    label: 'Issues',
                    icon: 'pi pi-exclamation-triangle',
                    command: () => navigate('/issues')
                },
                {
                    label: 'Tests',
                    icon: 'pi pi-file-check'
                }
            ]
        }
    ];
    const handleProjectSelection = async (e) => {
        e.preventDefault();
    };


    const start = (
        <div className="flex align-items-center gap-2">

            <Button
                icon={sidebarVisible ? 'pi pi-angle-left' : 'pi pi-angle-right'}
                text
                rounded
                onClick={() => setSidebarVisible(!sidebarVisible)}
            />
            <Image src="/images/Procon_SmallLogo_BlackOrange_mod.png" alt="Image" width="180" className="mt-1" />

            <span className="font-bold text-xl">
                Commission Hub &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
        </div>
    );
    // <ProjectContextDropdown onProjectChange={handleProjectSelection} />

    const end = (
        <div className="flex align-items-center gap-2">
            <Button icon="pi pi-bell" text rounded />
            <LogoutButton />
        </div>
    );

    return (
        <div className="h-screen w-full flex flex-column">

            {/* Top Navigation */}
            <Menubar
                model={topMenuItems}
                start={start}
                end={end}
            />

            {/* Main Content Area */}
            <div className="flex flex-1 overflow-hidden">

                {/* Left Sidebar */}
                {sidebarVisible && (
                    <div>
                        <PanelMenu model={panelItems} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} />
                    </div>
                )}

                {/* Page Content */}
                <div
                    className="
                        flex-1
                        overflow-y-auto
                        p-4
                    "
                >
                    <Outlet context={{ lookups }}/>
                </div>

            </div>

        </div>
    );
}